import type { HTMLAttributes, ReactNode } from "react";
import SidePanelLines from "./SidePanelLines";
import SkorLogo from "../SkorLogo/SkorLogo";
import "./SidePanel.css";

export interface SidePanelProps extends HTMLAttributes<HTMLElement> {
  /** "aside" for page side bars (default), "div" inside other layouts */
  as?: "aside" | "div";
  /** show the logo at the top (default true) */
  logo?: boolean;
  children?: ReactNode;
}

/**
 * The dark side panel used on the Welcome, login, sign-up and onboarding
 * pages: background, decorative lines and logo live here, once.
 * Background colour: --side-panel-bg (tokens), which brands can override
 * with --skor-color-sidebar-panel-bg.
 */
const SidePanel = ({
  as: Tag = "aside",
  logo = true,
  className = "",
  children,
  ...rest
}: SidePanelProps) => (
  <Tag className={`ds-side-panel ${className}`.trim()} {...rest}>
    <SidePanelLines />
    {logo && <SkorLogo className="ds-side-panel__logo" />}
    {children}
  </Tag>
);

export default SidePanel;
